export const ADMIN_UI_PATH = 'adminUIPath';
export const ADMIN_UI_CURRENT_CONTEXT = 'adminUICurrentContext';
export const ADMIN_UI_TOKEN_KIND = 'adminUITokenKind';
export const TOKEN_KIND_PROVISIONING = 'provisioning';

/**
 * What sessions written before the rename carry. Transitional: `sessionStorage` is per tab, so this
 * only covers a tab that was open across the deploy. Drop it, and the check below, once no such tab
 * can still exist.
 */
export const TOKEN_KIND_PROVISIONING_LEGACY = 'kalmar';

/**
 * Whether the session holds a provisioning (non-tenant) token.
 *
 * Read through one place so the legacy value is accepted everywhere or nowhere. The three callers
 * decide different things from it - skipping context resolution on the callback leg, accepting a
 * token with no `tenant_id` as authenticated, and NOT reconciling the context against the token
 * tenant - and a session that answered one of them differently from the others would be worse than
 * either value on its own.
 */
export const isProvisioningTokenKind = (value: string | null): boolean =>
  value === TOKEN_KIND_PROVISIONING || value === TOKEN_KIND_PROVISIONING_LEGACY;
